<script>
	import Dog from "../components/Dog.svelte";
	import SupportersText from "../components/SupportersText.svelte";
	// visual components

	// business logic
	import { isPortraitScreen } from '../js/model/stores';
	import { onMount } from 'svelte';

	let portrait;

	onMount(() => {
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	});


</script>

<style>
	section.portrait {
		padding-top: 8em;
	}

	.content {
		padding: 0;
	}

	.anchor {
		position: absolute;
		top: -10vh;
	}
</style>

<section class:portrait>
	<span class="anchor" id="supporter"></span>
	<Dog speedMultiplier="0.3"/>
	<div class="content">
		<h2>Unterstützer</h2>
		<SupportersText/>
	</div>
</section>
